import React from "react";
import { rawColors } from "../../../design-system/tokens/colors";
import type { CloseIconProps } from "./CloseIcon.types";

/** Figma component `x` (node 2858:216176) — 16×16, 8×8 stroke cross at inset 4. */
export const CloseIcon: React.FC<CloseIconProps> = ({
  size = 16,
  color = rawColors.text.mediumEmphasis,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M4 4L12 12M12 4L4 12"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
